import { Divider, HStack, Text, VStack } from '@chakra-ui/react';
import { formatCurrency } from '@web-app/components/ChartingNoteEditor/utils';
import { Benefits } from '@web-app/graphql/healthie/queries/get-client-insurance-details/types';

type Props = {
  benefits: Benefits;
};

/**
 * V2 version of PolicyBenefits for CallV2 layout.
 * Displays policy details like telemedicine, copay, deductible, and coinsurance.
 */
export const PolicyBenefitsV2 = ({ benefits }: Props) => {
  const list = [
    {
      label: 'Telemedicine',
      values: [benefits?.telemedicine ? 'Covered' : 'Not Covered'],
    },
    { label: 'Copay', values: [formatCurrency(benefits?.copay)] },
    {
      label: 'Deductible',
      values: [
        `${formatCurrency(benefits?.deductibleCalendarYear)} calendar year`,
        `${formatCurrency(benefits?.deductibleYearToDate)} year to date`,
        `${formatCurrency(+benefits?.deductibleCalendarYear - +benefits?.deductibleYearToDate)} remaining`,
      ],
    },
    { label: 'Coinsurance', values: [`${+(benefits?.coinsurance || 0)}%`] },
  ];
  return (
    <VStack
      align="flex-start"
      data-testid="policy-benefits"
      divider={<Divider borderColor="border.default" />}
    >
      {list.map((i, index) => (
        <HStack key={index} alignItems="center" width="100%">
          <Text opacity={0.7} fontSize="sm" width="50%">
            {i.label}
          </Text>
          <VStack width="50%" alignItems="flex-start">
            {i.values.map((v, subInd) => (
              <Text fontSize="sm" key={subInd}>
                {v}
              </Text>
            ))}
          </VStack>
        </HStack>
      ))}
    </VStack>
  );
};

PolicyBenefitsV2.displayName = 'PolicyBenefitsV2';
